import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {AppState} from '@/store/types'
import axios from 'axios'

type AppGetter = GetterTree<AppState, any>
type AppMutation = MutationTree<AppState>
type AppAction = ActionTree<AppState, any>

const state: AppState = {
    version: 0,
}

const getters: AppGetter = {
    appVersion: (state) => state.version,
}

const mutations: AppMutation = {
    setAppVersion: (state, payload) => {
        state.version = parseInt(payload, 10)
    },
}

const actions: AppAction = {
    getAppVersion: ({commit}) => {
        return new Promise((resolve, reject) => {
            axios.get(`mobile-app-version`).then((response) => {
                commit('setAppVersion', response.data)
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            })
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
}
